import { createLoader, parseAsString, parseAsStringLiteral } from 'nuqs';

import { DEALS_SORT_DIRECTIONS } from '@crm/entities/deal';
import { createIntegerRangeParser } from '@crm/shared/lib';

import { DEALS_TABLE_SORT_FIELDS } from './consts';

import type { UrlKeys } from 'nuqs';

export const DEFAULT_LOST_DEALS_SORT = DEALS_TABLE_SORT_FIELDS.lostAt;
export const DEFAULT_LOST_DEALS_DIRECTION = 'desc';

export const lostDealsSearchParams = {
    direction: parseAsStringLiteral(DEALS_SORT_DIRECTIONS),
    page: createIntegerRangeParser({ min: 1 }).withDefault(1),
    query: parseAsString,
    sort: parseAsStringLiteral(Object.values(DEALS_TABLE_SORT_FIELDS)),
    lostAtFrom: parseAsString,
    lostAtTo: parseAsString,
};

export const lostDealsSearchParamUrlKeys = {
    lostAtFrom: 'lost_at_from',
    lostAtTo: 'lost_at_to',
} satisfies UrlKeys<typeof lostDealsSearchParams>;

export const loadLostDealsSearchParams = createLoader(lostDealsSearchParams, {
    urlKeys: lostDealsSearchParamUrlKeys,
});
